<template>
  <div class="map-container vh-container">
    <osm-map :markers="this.markers" :noEmptyMessage="true" :search="true" :filters="true"></osm-map>
  </div>
</template>

<script>
  import api from '../../api'
  import helper from '../../helper'

  export default {
    props: [''],
    data () {
      return {
        markers: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadTestimonies()
      })
    },
    methods: {
      loadTestimonies () {
        api.authenticatedRequest('get', '/testimonies/all').then(response => {
          const data = response.data
          const testimonies = data.data

          this.markers = helper.extractTestimoniesMarkers(testimonies, true)
        })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      }
    }
  }
</script>

<style>
  .map-container {
    height: 2vh;
  }

  .vh-container #osm {
    height: calc(100vh - 53px - 53px);
  }
</style>



// WEBPACK FOOTER //
// Worldmap.vue?87d4eeae